import { render, staticRenderFns } from "./sp-ad.vue?vue&type=template&id=c6ab9812&scoped=true&"
import script from "./sp-ad.vue?vue&type=script&lang=js&"
export * from "./sp-ad.vue?vue&type=script&lang=js&"
import style0 from "./sp-ad.vue?vue&type=style&index=0&id=c6ab9812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ab9812",
  null
  
)

export default component.exports